import React from "react";
import { MessageCircle } from "lucide-react";
import { useLinks } from "../lib/useContent";
import { trackContact } from "../lib/metaPixel";

export const WhatsAppFloatButton: React.FC = () => {
  const links = useLinks();
  return (
    <a
      href={links.whatsappGeneral}
      onClick={() => trackContact("whatsapp_float")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Escríbenos por WhatsApp"
      className="fixed bottom-5 right-5 z-40 h-13 w-13 sm:h-14 sm:w-14 rounded-full bg-[#25D366] shadow-[0_10px_28px_-6px_rgba(0,0,0,0.4)] flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
      style={{ height: 56, width: 56 }}
    >
      <MessageCircle className="h-6 w-6 text-white" fill="white" />
    </a>
  );
};
